module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.2e26a916.ttf";